import { Component, Input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { AuthorDto, EditorDto } from '../../../../../api/responses'
import { FormatAuthorNamePipe } from '../../../../../shared/pipes/format-author-name.pipe'

@Component({
  selector: 'dhp-main-info',
  templateUrl: './main-info.component.html',
  styleUrls: ['./main-info.component.scss'],
  imports: [TranslatePipe, FormatAuthorNamePipe],
})
export class MainInfoComponent {
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() person!: AuthorDto | EditorDto

  isAuthor(person: AuthorDto | EditorDto): person is AuthorDto {
    return 'pdf_author_name' in person
  }

  getDepartment(): string | undefined {
    return this.person?.department
  }

  getAbout(): string | undefined {
    return this.person?.about
  }

  getCompanyName(): string | undefined {
    return this.person?.company_name
  }

  getFirmPage(): string | undefined {
    return this.person?.firm_page
  }

  getSocialLink(): string | undefined {
    return this.person?.social_link
  }

  // Check if we have any links to display
  hasLinks(): boolean {
    return (
      !!this.getDepartment() ||
      !!this.getCompanyName() ||
      !!this.getSocialLink() ||
      !!this.getFirmPage()
    )
  }
}
